export default {
  // Common uses
  'buttonAdd': '新增',
  'buttonBrowse': '瀏覽',
  'buttonCancel': '取消',
  'buttonClear': '清除',
  'buttonDelete': '刪除',
  'buttonDeleteData': '刪除資料',
  'buttonDeleteWatermark': '刪除水印',
  'buttonRemoveWatermark': '從顯示中移除浮水印',
  'buttonOk': '確定',
  'buttonSave': '儲存',
  'buttonSaveChanges': '儲存變更',
  'buttonSubmitting': '更新中...',
  'buttonSubmitData': '送出資料',
  'confirmRemoveFunc': '確定刪除該功能嗎？',
  'labelCompanyName': '翱騰國際科技股份有限公司',
  'labelDataLoading': '資料載入中...',
  'labelDbData': '資料庫資料',
  'labelHtmlFile': 'HTML 檔案',
  'labelNoDbDataFound': '資料庫中未找到資料',
  'labelRequired': '必填',
  'labelRequiredFields': '必填欄位',
  'labelSearch': '搜尋',
  'labelUrl': '網址',
  'notifAutoLoggedOut': '系統已自動登出，請重新登入',
  'notifGetTokenError': '系統錯誤，無法取得 Token',
  'placeholderEnter': '請輸入',
  "autoCreateKey":"未能自動插入新鍵",
  'refresh':'Refresh',
  // Login.vue
  'buttonLogin': '登入',
  'buttonCreateAccount': '建立帳號',
  'labelCopyrightMessage': '保留所有權利',
  'labelCreateNewAcccount': '建立新帳號',
  'labelDataRetrieveFail': '無法從伺服器取得資料',
  'labelInitializing': '初始化中...',
  'labelSignInMessage': '登入您的帳號',
  'labelWelcomeMessage': 'OneConsole',
  'notifAccountAllInvalid': '輸入不符合任何條件',
  'notifAccountStarnumInvalid': '*StarNumber 無效，請保持在10-12字元以內',
  'notifLoginError': `登入使用者 'user_id' 失敗。錯誤訊息: error_message`,
  'notifLoginSuccess': `登入使用者 'user_id' 成功`,
  'notifNoRolesAssigned': '此帳號未分配角色！',
  'placeholderAccount': '輸入您的帳號',
  'placeholderPxd': '輸入您的密碼',
  'placeholderSelectCompanyID': '選擇公司 ID',
  'notifErrorListDb': '呼叫 /listdb API 失敗',
  'notifErrorLoadLanguage': '載入 language.db 失敗',
  'notifErrorLoadSettings': '載入設定失敗',
  'notifNoCidFound': '找不到公司 ID',
  // AppHeaderDropdownNotif.vue
  'labelNewNotification': '新',
  'labelNewNotificationMessage': '訊息',
  'labelConfirmAction': '確認操作',
  'labelNoNotifications': '沒有通知',
  'titleAlertNotification': '警示通知',
  'titleInfoNotification': '資訊通知',
  'titleOtherNotification': '其他通知',
  'titleWarningNotification': '警告通知',
  // AppHeaderDropdownAcct.vue
  'confirmLogout': '您確定要登出嗎？',
  'labelSettings': '設定',
  'labelChangeCompanyId': '變更公司代碼',
  'labelPluginManage': '管理插件',
  'labelPluginInstall': '安裝插件',
  'labelGetAccount': '授權',
  'labelChangePxd': '變更密碼',
  'labelLogout': '登出',
  // AppSidebar.vue，IStoreSidebarNav.vue
  'labelAddNode': '新增節點',
  'labelAddPlugin': '新增插件',
  'labelAddRoot': '新增根目錄',
  'labelEditNode': '編輯節點',
  'labelEditPlugin': '編輯插件',
  'labelEditRoot': '編輯根目錄',
  'labelRemoveNode': '刪除節點',
  'labelRemovePlugin': '刪除插件',
  'labelRemoveRoot': '刪除根目錄',
  // DefaultLayout.vue
  'notifRemoveNodeError': '節點刪除錯誤！',
  'notifRemoveNodeSuccess': '節點刪除成功',
  'notifRemovePluginError': '插件刪除錯誤！',
  'notifRemovePluginSuccess': '插件刪除成功',
  'notifRemoveRootError': '根目錄刪除錯誤！',
  'notifRemoveRootSuccess': '根目錄刪除成功',
  // FunctionCreator.vue, FunctionEditor.vue
  'buttonAddField': '新增欄位',
  'labelAddOneField': `請在點擊 'which_button' 送出前至少新增一個欄位`,
  'labelDatabase': '資料庫',
  'labelDisabled': '停用',
  'labelDisplayName': '顯示名稱',
  'labelModule': '模組',
  'labelName': '名稱',
  'labelOrder': '排序',
  'labelParent': '路徑',
  'labelRequiredDisplayName': '請輸入顯示名稱',
  'labelRequiredKey': '請輸入資料庫 KEY',
  'labelRequiredModule': '請輸入模組',
  'labelRequiredName': '請輸入名稱',
  'labelType': '儲存類型',
  'notifAddNodeSuccess': '新增節點成功',
  'notifAddNodeError': '新增節點失敗',
  'notifHideNodeSuccess': '節點隱藏成功',
  'optionCustom': '自訂',
  'optionJson': 'JSON',
  'optionPath': '路徑',
  'optionUrl': 'URL',
  'placeholderDisplayName': '輸入顯示名稱',
  'placeholderField': '輸入欄位名稱',
  'placeholderKey': '輸入資料庫 KEY',
  'placeholderModule': '輸入模組',
  'placeholderName': '輸入名稱',
  'placeholderNameTable': '自動填寫由',
  'placeholderOrder': '輸入排序',
  'titleAddNode': '新增節點',
  'titleEditNode': '編輯節點',
  'titleTableFieldName': '欄位名稱',
  'titleTableFieldType': '欄位類型',
  'titleTableFormat': '格式',
  'titleTableInRow': '在列中',
  'titleTableInSearch': '在搜尋中',
  'titleTableRequired': '必填',
  'titleTableRemove': '移除',
  // CreateNewData.vue, DataViewer.vue, DataEditor.vue
  'confirmDataDelete': '您確定要刪除資料嗎？',
  'labelDataFound': '找到資料',
  'labelDisplayRows': '每頁顯示',
  'labelEntries': '條目',
  'labelNoDataFound': `在 item_database 資料庫中找不到資料`,
  'labelNoDataFoundSearch': `在 item_database 資料庫中找不到以 search_term 搜尋的資料`,
  'labelSelected': '已選擇',
  'labelOf': '共',
  'labelRows': '筆',
  'labelRequiredDate': '請設定日期',
  'labelRequiredEmail': '請輸入電子郵件',
  'labelRequiredNumber': '請輸入數字',
  'labelRequiredString': '請輸入資料',
  'labelSearchBy': '搜尋',
  'labelShowing': '顯示中',
  'labelTotalData': '資料總筆數',
  'notifAddDataError': '新增資料失敗',
  'notifAddDataSuccess': '資料新增成功',
  'notifDataEditError': '資料變更失敗',
  'notifDataEditSuccess': '資料編輯成功',
  'notifDataDeleteError': '刪除資料失敗',
  'notifDataDeleteSuccess': '資料刪除成功',
  'notifEditNodeError': '無法編輯節點',
  'notifEditNodeSuccess': '節點編輯成功',
  'notifKeyNotFound': '未找到 KEY',
  'notifJsonEditError': '資料解析失敗，請重新檢查您的編輯',
  'notifPropertiesEditError': '屬性字串格式錯誤，請重新檢查您的編輯',
  'placeholderAddDbKey': '資料庫金鑰 (自動填寫)',
  'titleAddDataModal': '新增資料',
  'titleEditDataModal': '編輯資料',
  'tooltipAddDataButton': '新增資料',
  'tooltipDeleteDataButton': '刪除資料',
  'tooltipExportDataButton': '導出資料',
  'tooltipImportDataButton': '導入資料',
  'tooltipShowCheckboxButton': '顯示複選框（選擇資料）',
  // ImportExportModal.vue
  'labelChooseOneOfColumns': '選擇一列',
  'labelExportAs': '導出為',
  'labelSelectAll': '全選',
  'labelChooseColumnsToExport': '選擇要匯出的欄位',
  'labelChooseColumnsToImport': '選擇要匯入的欄位',
  'notifImportDataSuccess': '資料導入成功',
  'notifImportDataError': '導入資料錯誤',
  'notifInvalidCsv': '無效的 CSV 檔案',
  'placeholderExportFilename': '匯出檔名',
  'titleExportDataModal': '導出資料',
  'titleImportDataModal': '導入資料',
  // AccountCreator.vue, AccountEditor.vue
  'buttonAddUser': '新增使用者',
  'buttonEditUser': '編輯使用者',
  'buttonRemoveUser': '移除使用者',
  'labelActions': '操作',
  'labelActivated': '已啟動',
  'labelActivatedDate': '啟動日期',
  'labelDateEmpty': '請輸入日期',
  'labelEmail': '電子郵件',
  'labelInvalidEmailFmt': '電子郵件格式無效，請輸入類似: test@mail.com',
  'labelLanguage': '語言',
  'labelPxd': '密碼',
  'labelSuspend': '暫停',
  'labelUserId': '使用者代碼',
  'labelUserName': '使用者名稱',
  'labelUserStatus': '使用者狀態',
  'labelRole': '角色',
  'labelCid': '公司 ID',
  'labelDepartment' : "部門",
  'notifAddUserError': '註冊使用者失敗！',
  'notifAddUserSuccess': '使用者註冊成功',
  'notifDifferentUidEmail': '使用者 ID 與電子郵件不相符！',
  'notifDuplicateData': '使用者 ID 已被使用！',
  'notifModifyUserError': '編輯使用者資料失敗！',
  'notifModifyUserSuccess': '使用者資料編輯成功',
  'notifNoWhiteSpcUid': '使用者 ID 不允許有空格！',
  'notifSetActivatedDate': '請設定\'啟動日期\'!',
  'placeholderEmail': '輸入電子郵件',
  'placeholderUserId': '輸入使用者帳號',
  'placeholderUserName': '輸入使用者名稱',
  'titleAddNewUser': '新增使用者',
  'titleEditUserData': '編輯使用者資料',
  'titleShowPxd': '點選以顯示密碼',
  'notifCopyPxd': '密碼已複製到剪貼簿！',
  'labelResetPxd': '重設密碼',
  'notifChooseCid': '請選擇公司 ID',
  'system.accountManager.column.userName': '使用者名稱',
  'system.accountManager.column.roleNames': '角色',
  // ChangePxd.vue
  'labelConfirmNewPxd': '確認新密碼',
  'labelCurrentPxd': '當前密碼',
  'labelNewPxd': '新密碼',
  'placeholderConfirmNewPxd': '重新輸入新密碼',
  'placeholderCurrentPxd': '輸入當前密碼',
  'placeholderNewPxd': '輸入新密碼',
  'notifChangePxdError': '密碼變更失敗',
  'notifChangePxdSuccess': '密碼變更成功',
  'notifPxdIncorrect': '密碼不正確！',
  'notifPxdInvalid': '密碼格式無效！',
  'notifPxdNotFound': '找不到密碼！',
  'notifPxdRecheck': '請重新檢查新密碼！',
  'titleChangePxd': '變更密碼',
  // PluginManager.vue
  'titlePluginManage': '管理插件',
  'buttonPluginUpdate': '更新插件',
  'buttonPluginInstall': '安裝插件',
  'buttonExcludePlugin': '排除',
  'buttonIncludePlugin': '包括',
  'notifInstallPluginSuccess':'插件安裝成功！',
  'notifDataNeed2BeSelected':'至少選擇一個插件',
  'labelInstallPlugin':'新增插件',
  // GetAccount.vue
  'titleGetAcc':'授權',
  'labelSerialNumber':'驗證碼',
  'placeholderSerialNumber':'輸入驗證碼',
  'labelIPAddr':'外部 IP 位址',
  'placeholderIPAddr':'輸入外部 IP 位址',
  'labelMACAddr':'網卡實體位址',
  'placeholderMACAddr':'輸入網卡實體位址',
  'labelProvisioning':'佈建中...',
  // RoleCreator.vue, RoleEditor.vue
  'labelRoleName': '角色名稱',
  'labelRoleId': '角色編號',
  'labelLevelId': '角色層級',
  'labelFunctionsToAssign': '指派功能',
  'titleAddRoleModal': '定義新角色',
  'titleEditRoleModal': '編輯角色',
  // BackupServerCreator.vue, BackupServerEditor.vue
  'labelCompanyId': '公司 ID',
  'labelCompanyIdExists': '公司 ID 已存在',
  'labelEncrypt': '加密',
  'labelFileUrl': '文件 URL',
  'labelImAddress': '即時通訊地址',
  'labelIndexServers': '索引伺服器',
  'labelPushServicePort': '推送服務連接埠',
  'labelPushServicePortal': '推送服務入口網站',
  'labelStarNumberType': '星號類型',
  'labelStarVPort': 'StarV 連接埠',
  'notifAddServerBackupError': '新增備份伺服器設定失敗！',
  'notifAddServerBackupSuccess': '新增備份伺服器設定成功',
  'notifEditServerBackupError': '編輯備份伺服器設定失敗！',
  'notifEditServerBackupSuccess': '編輯備份伺服器設定成功',
  'notifCheckRequiredData': '檢查所需資料是否為空',
  'notifDuplicateCompanyId': '公司 ID 已存在！請使用其他公司 ID',
  'placeholderCompanyId': '輸入公司 ID',
  'placeholderFileUrl': '輸入檔案 URL',
  'placeholderIMAddr': '輸入即時通訊地址',
  'placeholderINode': '輸入 iNode 設定',
  'placeholderIp': '輸入 IP 配置',
  'placeholderPushServicePort': '輸入推播服務埠',
  'placeholderPushServicePortal': '輸入推播服務入口網站',
  'placeholderStarNumberType': '輸入星號類型',
  'placeholderStarVPort': '輸入 StarV 埠',
  'titleAddBackupServer': '新增備份伺服器',
  'titleEditBackupServer': '編輯備份伺服器',
  // Page404.vue
  'labelPage404Message': '找不到您正在尋找的頁面',
  'titlePage404': '對不起',
  // WatermarkSetting.vue
  'confirmWatermarkDelete': '您確定要刪除此水印嗎？',
  'labelAddNewWatermark': '新增浮水印',
  'labelNoWatermark': '無水印',
  'labelSelectWatermark': '選擇水印',
  'labelWatermarkFile': '水印檔案',
  'labelWatermarkName': '水印名稱',
  'labelWatermarkPreview': '預覽',
  'labelWatermarkSetting': '水印設定',
  'notifAddWatermarkError': '新增浮水印失敗！',
  'notifAddWatermarkSuccess': '成功新增浮水印',
  'notifDeleteWatermarkError': '刪除 \'watermark_name\' 水印失敗！',
  'notifDeleteWatermarkSuccess': '成功刪除 \'watermark_name\' 水印',
  'notifSetWatermarkError': '設定浮水印失敗！',
  'notifSetWatermarkSuccess': '設定浮水印成功',
  'placeholderWatermarkFile': '上傳水印檔案',
  'placeholderWatermarkName': '輸入水印名稱',
  'placeholderWatermarkSelect': '選擇浮水印',
  'titleWatermarkSetting': '水印設定',
  // DepartmentManager.vue
  "titleAddDepartmentModal": "新增部門",
  "titleEditDepartmentModal": "編輯部門",
  "system.departmentManager.column.departmentName": "部門名稱",
  "system.departmentManager.column.departmentDescription": "部門描述",
  "system.departmentManager.column.users": "使用者",
  "system.departmentManager.column.roles": "角色",
  // LanguageCreator.vue, LanguageEditor.vue
  'labelLangKey': 'KEY',
  'labelEnglish': '英文',
  'labelTaiwanese': '中文（繁體）',
  'labelChinese': '中文（簡體）',
  'labelJapanese': '日文',
  "titleAddLanguageData": "新增語言資料",
  "titleEditLanguageData": "編輯語言資料",
  // PluginInstaller.vue
  "labelPluginName":"插件名稱",
  'notifAddBinSuccess': '二進位檔上傳成功',
  'notifSetBinError': '二進位檔上傳失敗！',
  // ApiManager.vue
  'system.apiManager':'API Manager'
}
